/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Not_Found_TitleInputs */

const en_control_not_found_title = /** @type {(inputs: Control_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Signal lost`)
};

const zh_control_not_found_title = /** @type {(inputs: Control_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面未找到`)
};

/**
* | output |
* | --- |
* | "404 — Signal lost" |
*
* @param {Control_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_not_found_title = /** @type {((inputs?: Control_Not_Found_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Not_Found_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_not_found_title(inputs)
	return zh_control_not_found_title(inputs)
});
export { control_not_found_title as "control.not_found.title" }